import React, { useEffect, useMemo, useState } from "react";

import * as S from "./styles";
import { AddButton, FH, Title } from "../../main-styles";
import WhiteBox from "../../../components/WhiteBox";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCoin,
  faEye,
  faEyeSlash,
  faMagnifyingGlass,
  faPencil,
  faTrash,
  faBoxOpen,
  faFireAlt,
  faTriangleExclamation,
  faRocket,
  faBell,
} from "@fortawesome/pro-light-svg-icons";
import { faCheckCircle, faCircle } from "@fortawesome/pro-light-svg-icons";
import { useTheme } from "styled-components";
import { useNavigate } from "react-router";
import { getProdutos, setProcutStatus } from "../../../api/produtos";
import { Spinner } from "reactstrap";
import toast from "react-hot-toast";
import { useConfirm } from "../../../components/ConfirmProvider";
import styled from "styled-components";

function Produtos() {
  const navigate = useNavigate();
  const theme = useTheme();
  const confirm = useConfirm();
  window.document.title = "Organnact - Admin - Produtos";
  const [produtos, setProdutos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10000);
  const [needle, setNeedle] = useState("");
  const [hideInactive, setHideInactive] = useState(false);

  useEffect(() => {
    loadProdutos();
  }, [page, perPage, needle]);

  async function loadProdutos() {
    setLoading(true);
    const nprodutos = await getProdutos(page, perPage, needle, true);
    setProdutos(nprodutos);
    setLoading(false);
  }

  function gotoEdit(id) {
    navigate(`/admin/produtos/editar/${id}`);
  }

  async function _toggleActive(id) {
    const produto = produtos.find((p) => p.id === id);
    if (!produto) return;
    const newStatus = produto.status === "active" ? "inactive" : "active";
    const acao = newStatus === "active" ? "ativar" : "desativar";
    if (
      !(await confirm({
        title: `${acao[0].toUpperCase()}${acao.slice(1)} produto`,
        message: `Tem certeza que deseja ${acao} o produto "${produto.nome}"?`,
        confirmText: acao[0].toUpperCase() + acao.slice(1),
      }))
    )
      return;
    toast.promise(
      setProcutStatus(id, newStatus),
      {
        loading: `Alterando status...`,
        success: () => {
          setProdutos((prev) =>
            prev.map((p) => (p.id === id ? { ...p, status: newStatus } : p))
          );
          return `Produto ${newStatus === "active" ? "ativado" : "desativado"}!`;
        },
        error: `Erro ao alterar status.`,
      }
    );
  }

  async function _deleteProduto(id) {
    if (
      !(await confirm({
        title: "Excluir produto",
        message: "Tem certeza que deseja excluir este produto?",
        confirmText: "Excluir",
        danger: true,
      }))
    )
      return;
    toast.promise(
      setProcutStatus(id, "deleted"),
      {
        loading: "Excluindo produto...",
        success: () => {
          setProdutos((prev) => prev.filter((p) => p.id !== id));
          return "Produto excluído com sucesso!";
        },
        error: "Erro ao excluir o produto.",
      }
    );
  }

  const filtered = useMemo(() => {
    if (hideInactive) return produtos.filter((p) => p.status === "active");
    return produtos;
  }, [produtos, hideInactive]);

  const totalActive = produtos.filter((p) => p.status === "active").length;
  const totalInactive = produtos.filter((p) => p.status !== "active").length;

  if (loading) {
    return (
      <S.Container>
        <WhiteBox style={{ padding: 40, textAlign: "center" }}>
          <Spinner />
        </WhiteBox>
      </S.Container>
    );
  }

  return (
    <S.Container>
      <FH
        style={{
          gap: 10,
          alignItems: "flex-end",
          justifyContent: "space-between",
          marginBottom: 0,
        }}
      >
        <div>
          <Title>Produtos</Title>
          <span style={{ fontSize: 12, color: "#999" }}>
            {totalActive} ativos
            {totalInactive > 0 && ` / ${totalInactive} inativos`}
          </span>
        </div>
        <AddButton onClick={() => navigate("/admin/produtos/novo")}>
          Adicionar novo produto
        </AddButton>
      </FH>
      <WhiteBox style={{ borderTopRightRadius: 0 }}>
        <ToolBar>
          <SearchWrap>
            <SearchIcon>
              <FontAwesomeIcon icon={faMagnifyingGlass} />
            </SearchIcon>
            <SearchInput
              type="text"
              placeholder="Buscar por nome do produto..."
              value={needle}
              onChange={(e) => setNeedle(e.target.value)}
            />
          </SearchWrap>
          <ToggleWrap onClick={() => setHideInactive(!hideInactive)}>
            <FontAwesomeIcon
              icon={hideInactive ? faCheckCircle : faCircle}
              style={{ color: hideInactive ? "#3483fa" : "#ccc" }}
            />
            <span>Ocultar inativos</span>
          </ToggleWrap>
        </ToolBar>

        <TableWrap>
          <table className="table table-sm" style={{ marginBottom: 0 }}>
            <thead>
              <tr>
                <th style={{ width: 50 }}></th>
                <th>Produto</th>
                <th style={{ width: 80 }}>Divisão</th>
                <th style={{ width: 80, textAlign: "center" }}>Vendas</th>
                <th style={{ width: 80, textAlign: "center" }}>Estoque</th>
                <th style={{ width: 110, textAlign: "center" }}>Interesse</th>
                <th style={{ width: 100 }}>Preço</th>
                <th style={{ width: 60, textAlign: "center" }}>Status</th>
                <th style={{ width: 130, textAlign: "right" }}>Ações</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((produto) => {
                const isActive = produto.status === "active";
                const isPreLancamento = produto.status === "pre_lancamento";
                const tipos = produto.tipo || [];
                return (
                  <tr
                    key={produto.id}
                    style={{
                      opacity: isActive || isPreLancamento ? 1 : 0.55,
                      cursor: "pointer",
                    }}
                    onClick={() => gotoEdit(produto.id)}
                  >
                    <td style={{ verticalAlign: "middle" }}>
                      {produto.imagens?.[0] ? (
                        <img
                          src={produto.imagens[0]}
                          alt=""
                          style={{
                            width: 40,
                            height: 40,
                            objectFit: "contain",
                            borderRadius: 4,
                            background: "#f5f5f5",
                          }}
                        />
                      ) : (
                        <div
                          style={{
                            width: 40,
                            height: 40,
                            borderRadius: 4,
                            background: "#f5f5f5",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <FontAwesomeIcon icon={faBoxOpen} color="#ccc" />
                        </div>
                      )}
                    </td>
                    <td style={{ verticalAlign: "middle" }}>
                      <div style={{ fontWeight: 500, fontSize: 14, color: "#333" }}>
                        {produto.nome}
                      </div>
                      <div style={{ fontSize: 11, color: "#999" }}>
                        {produto.id_everest || `#${produto.id}`}
                        {produto.destaque && (
                          <span style={{ color: "#ff5900", marginLeft: 8 }}>
                            <FontAwesomeIcon icon={faFireAlt} /> Destaque
                          </span>
                        )}
                      </div>
                    </td>
                    <td style={{ verticalAlign: "middle" }}>
                      <div style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
                        {tipos.includes("pet") && <DivisaoBadge $tipo="pet">PET</DivisaoBadge>}
                        {tipos.includes("equi") && <DivisaoBadge $tipo="equi">EQUI</DivisaoBadge>}
                        {tipos.length === 0 && (
                          <FontAwesomeIcon
                            icon={faTriangleExclamation}
                            style={{ color: "#f9a825", fontSize: 14 }}
                            title="Sem divisão definida"
                          />
                        )}
                      </div>
                    </td>
                    <td style={{ verticalAlign: "middle", textAlign: "center", fontSize: 13 }}>
                      {produto.vendas || 0}
                    </td>
                    <td style={{ verticalAlign: "middle", textAlign: "center", fontSize: 13 }}>
                      <span
                        style={{
                          color: produto.stock <= 0 ? "#d32f2f" : produto.stock < 5 ? "#f57c00" : "#333",
                          fontWeight: produto.stock <= 0 ? 600 : 400,
                        }}
                      >
                        {produto.stock || 0}
                      </span>
                    </td>
                    <td
                      style={{ verticalAlign: "middle", textAlign: "center" }}
                      onClick={(e) => e.stopPropagation()}
                    >
                      <InteresseWrap>
                        {produto.count_preorder > 0 && (
                          <InteresseBadge
                            $tipo="preorder"
                            title="Pessoas inscritas em pre-venda"
                            onClick={() =>
                              navigate(
                                `/admin/produtos/${produto.id}/interessados?tipo=preorder`
                              )
                            }
                          >
                            <FontAwesomeIcon icon={faRocket} />{" "}
                            {produto.count_preorder}
                          </InteresseBadge>
                        )}
                        {produto.count_notify > 0 && (
                          <InteresseBadge
                            $tipo="notify"
                            title="Pessoas aguardando aviso"
                            onClick={() =>
                              navigate(
                                `/admin/produtos/${produto.id}/interessados?tipo=notify`
                              )
                            }
                          >
                            <FontAwesomeIcon icon={faBell} />{" "}
                            {produto.count_notify}
                          </InteresseBadge>
                        )}
                      </InteresseWrap>
                    </td>
                    <td style={{ verticalAlign: "middle", fontSize: 14 }}>
                      <FontAwesomeIcon
                        icon={faCoin}
                        color={theme.primary}
                        style={{ marginRight: 4, fontSize: 12 }}
                      />
                      {produto.preco}
                    </td>
                    <td style={{ verticalAlign: "middle", textAlign: "center" }}>
                      {isActive ? (
                        <StatusDot $color="#4caf50" title="Ativo" />
                      ) : isPreLancamento ? (
                        <StatusDot $color="#2196f3" title="Pré-venda" />
                      ) : (
                        <StatusDot $color="#bbb" title="Inativo" />
                      )}
                    </td>
                    <td
                      style={{ verticalAlign: "middle", textAlign: "right" }}
                      onClick={(e) => e.stopPropagation()}
                    >
                      <ActionBtn
                        title="Editar"
                        onClick={() => gotoEdit(produto.id)}
                      >
                        <FontAwesomeIcon icon={faPencil} />
                      </ActionBtn>
                      <ActionBtn
                        title={isActive ? "Desativar" : "Ativar"}
                        onClick={() => _toggleActive(produto.id)}
                      >
                        <FontAwesomeIcon icon={isActive ? faEyeSlash : faEye} />
                      </ActionBtn>
                      {produto.vendas === 0 && (
                        <ActionBtn
                          title="Excluir"
                          $danger
                          onClick={() => _deleteProduto(produto.id)}
                        >
                          <FontAwesomeIcon icon={faTrash} />
                        </ActionBtn>
                      )}
                    </td>
                  </tr>
                );
              })}
              {filtered.length === 0 && (
                <tr>
                  <td colSpan="9" style={{ textAlign: "center", padding: 30, color: "#999" }}>
                    Nenhum produto encontrado.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </TableWrap>
      </WhiteBox>
    </S.Container>
  );
}

const ToolBar = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 16px;
  flex-wrap: wrap;
`;

const SearchWrap = styled.div`
  flex: 1;
  min-width: 200px;
  position: relative;
  display: flex;
  align-items: center;
`;

const SearchIcon = styled.div`
  position: absolute;
  left: 12px;
  color: #999;
  font-size: 14px;
  pointer-events: none;
`;

const SearchInput = styled.input`
  width: 100%;
  padding: 10px 12px 10px 36px;
  font-size: 14px;
  font-family: 'Montserrat', sans-serif;
  border: 1px solid #ddd;
  border-radius: 6px;
  background: #f9f9f9;
  color: #333;
  transition: border-color 0.2s;

  &:focus {
    outline: none;
    border-color: #3483fa;
    background: #fff;
  }

  &::placeholder {
    color: #aaa;
  }
`;

const ToggleWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #666;
  cursor: pointer;
  white-space: nowrap;
  user-select: none;

  &:hover {
    color: #333;
  }
`;

const TableWrap = styled.div`
  overflow-x: auto;
`;

const DivisaoBadge = styled.span`
  font-size: 10px;
  font-weight: 700;
  padding: 2px 6px;
  border-radius: 3px;
  letter-spacing: 0.5px;
  background: ${(props) => (props.$tipo === "equi" ? "#e3f2fd" : "#fff8e1")};
  color: ${(props) => (props.$tipo === "equi" ? "#1565c0" : "#f57f17")};
`;

const InteresseWrap = styled.div`
  display: inline-flex;
  gap: 4px;
  align-items: center;
  justify-content: center;
`;

const InteresseBadge = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 12px;
  border: 1px solid transparent;
  cursor: pointer;
  background: ${(p) => (p.$tipo === "preorder" ? "#e3f2fd" : "#f5f5f5")};
  color: ${(p) => (p.$tipo === "preorder" ? "#1565c0" : "#666")};
  transition: filter 0.15s, border-color 0.15s;

  &:hover {
    filter: brightness(0.95);
    border-color: ${(p) => (p.$tipo === "preorder" ? "#1565c0" : "#999")};
  }
`;

const StatusDot = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: ${(props) => props.$color};
  display: inline-block;
`;

const ActionBtn = styled.button`
  background: none;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 6px 8px;
  font-size: 13px;
  color: ${(props) => (props.$danger ? "#d32f2f" : "#555")};
  cursor: pointer;
  margin-left: 4px;
  transition: all 0.15s;

  &:hover {
    background: ${(props) => (props.$danger ? "#ffebee" : "#f5f5f5")};
    border-color: ${(props) => (props.$danger ? "#d32f2f" : "#ccc")};
  }
`;

export default Produtos;
